import { render, staticRenderFns } from "./deduction-list.vue?vue&type=template&id=67f9f694&"
import script from "./deduction-list.vue?vue&type=script&lang=js&"
export * from "./deduction-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports